export default "__VITE_ASSET__MYDPx1BB__"